import { format } from 'date-fns';

const LOGIN_EVENT = 'LOGIN';
const PRE_IMAGE_URL = '//picture-controlinn.s3.amazonaws.com/util/preimage.png';
const TURNOVER_IMAGE_URL = '//picture-controlinn.s3.amazonaws.com/housekeeping/settings/icons/turnover.svg';
const MAINTENANCE_IMAGE_URL = '//picture-controlinn.s3.amazonaws.com/housekeeping/settings/icons/maintenance.svg';
const CLEANDEEP_IMAGE_URL = '//picture-controlinn.s3.amazonaws.com/housekeeping/settings/icons/cleandeep.svg';
const OUTOFSERVICE_IMAGE_URL = '//picture-controlinn.s3.amazonaws.com/housekeeping/settings/icons/outofservice.svg';
const LOCKED_IMAGE_URL = '//picture-controlinn.s3.amazonaws.com/housekeeping/settings/icons/locked.svg';
const DIRTY_IMAGE_URL = '//picture-controlinn.s3.amazonaws.com/housekeeping/settings/icons/dirty.svg';
const INDETERMINATE_IMAGE_URL = '//picture-controlinn.s3.amazonaws.com/housekeeping/settings/icons/indeterminate.svg';
const ES_IMAGE_URL = '//picture-controlinn.s3.amazonaws.com/webqp/flagspain.svg';
const EN_IMAGE_URL = '//picture-controlinn.s3.amazonaws.com/webqp/flagusa.png';
const PE_IMAGE_URL = '//picture-controlinn.s3.amazonaws.com/company/flags/peru.jpg';

/* eslint-disable */
function debounce(func, wait = 800, immediate) {
	var timeout;
	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};

function generateBlob(dataBlob, contentType = 'application/pdf') {
	return new Blob([dataBlob], { type: contentType });
}

function getHousemaidAssign() {
	return JSON.parse(localStorage.getItem(`${process.env.STORAGE_USER_KEY}::housemaid-assign`));
}

function getRoute(name) {
	return { name };
}

function getUser() {
	return JSON.parse(localStorage.getItem(process.env.STORAGE_USER_KEY));
}

function getToken() {
	return localStorage.getItem(`${process.env.STORAGE_USER_KEY}::token`);
}

function removeHousemaidAssign() {
	localStorage.removeItem(`${process.env.STORAGE_USER_KEY}::housemaid-assign`);
}

function removeUserData() {
	localStorage.removeItem(process.env.STORAGE_USER_KEY);
	localStorage.removeItem(`${process.env.STORAGE_USER_KEY}::token`);
}

function saveHousemaidAssign(model) {
	return localStorage.setItem(`${process.env.STORAGE_USER_KEY}::housemaid-assign`, JSON.stringify(model));
}

function showDownloadDialog(blob, name, extension, preview) {
	const currentDate = format(new Date(), 'YYYY-MM-DD');
	const link = document.createElement('a');
	link.download = `${name}_${currentDate}.${extension}`;
	link.href = window.URL.createObjectURL(blob);
	link.click();
	if (preview) {
		window.open(link.href);
	}
}

function formatDate(date, formatter = 'DD-MM-YYYY') {
	const newDate = format(new Date(date), formatter);
	return newDate;
}

function data() {
	return {
		loginEvent: LOGIN_EVENT,
		preimageUrl: PRE_IMAGE_URL,
		turnoverImageUrl: TURNOVER_IMAGE_URL,
		maintenanceImageUrl: MAINTENANCE_IMAGE_URL,
		cleandeepImageUrl: CLEANDEEP_IMAGE_URL,
		outofserviceImageUrl: OUTOFSERVICE_IMAGE_URL,
		lockedImageUrl: LOCKED_IMAGE_URL,
		dirtyImageUrl: DIRTY_IMAGE_URL,
		indeterminateImageUrl: INDETERMINATE_IMAGE_URL,
		flagEs: ES_IMAGE_URL,
		flagEn: EN_IMAGE_URL,
		flagPe: PE_IMAGE_URL,
	};
}

const helper = {
	data,
	methods: {
		debounce,
		formatDate,
		generateBlob,
		getHousemaidAssign,
		getRoute,
		getUser,
		getToken,
		removeHousemaidAssign,
		removeUserData,
		saveHousemaidAssign,
		showDownloadDialog,
	},
};

export default helper;



// WEBPACK FOOTER //
// ./src/shared/helper.js